/** Checks if input is of form YYYY-MM-DD */
export default function isoDateIsValid(isoDate) {
    return /^\d{4}-\d{2}-\d{2}$/.test(isoDate);
}
